import styled from "styled-components"
import { FlexipageColors } from "../../Flexipage/Global/FlexipageStyles"

export const HomeHeroWrapper = styled.section`
	font-family: Poppins, sans-serif;

	.container {
		display: flex;
		flex-direction: column;
		gap: 3rem;
	}

	h1 {
		max-width: 1000px;
		margin-inline: auto;
		margin-bottom: 0;

		text-align: center;
		text-wrap: balance;
		font-size: 56px;
		line-height: 1.2;
		font-weight: bold;
		font-family: Ambit, sans-serif;

		@media screen and (max-width: ${FlexipageColors.breakpointTablet}) {
			font-size: 48px;
		}

		@media screen and (max-width: ${FlexipageColors.breakpointMobile}) {
			font-size: 40px;
		}
	}

	.buttons {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		gap: 2rem;

		> * {
			flex-shrink: 0;
		}
	}

	.btn {
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
		background: ${FlexipageColors.teal1000};
		color: white;
		font-weight: 500;
		border-radius: 0.5rem;
		padding: 0.625rem 0.825rem;
		font-size: 1rem;
		line-height: 1.2;

		&:hover,
		&:focus-visible {
			background-color: ${FlexipageColors.teal1200};
		}

		&:focus {
			box-shadow: none;
		}

		&:focus-visible {
			outline: 2px solid ${FlexipageColors.blue1000};
			outline-offset: 2px;
		}

		&.ghost {
			background: transparent !important;
			color: ${FlexipageColors.blue1000};

			&:hover {
				text-decoration: underline;
			}
		}

		svg {
			height: 1rem;
			color: inherit;
			flex-shrink: 0;
		}
	}

  .animation {
		margin-top: 2.5rem;
		max-height: 75dvh;
		margin-inline: auto;
		background-color: #efefef;
		border-radius: 2rem;
    overflow: hidden;
	}
`